<form>
  <mat-form-field class="full-width {{customCssClasses ? customCssClasses.join(' ') : ''}}">
    <mat-label>{{ displayLabel }}</mat-label>
    <mat-select [(value)]="selectedValue"
                [disabled]="disabled"
                [required]="required"
                (selectionChange)="onValueChange()"
                [attr.data-qa]="qaAttr"
                [attr.data-element]="'qa-element-single-select'">
      <mat-option *ngFor="let option of displayOptions" [value]="option">{{ option }}</mat-option>
    </mat-select>
  </mat-form-field>
</form>
